var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report_row page"},[_c('div',{staticClass:"sub_header"},[_vm._v(_vm._s(_vm.$t('report.paper.expert_opinion')))]),_c('div',{staticClass:"text_area"},[_vm._v("\n\t\t"+_vm._s(_vm.expertOpinionContext)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }